<template>
  <div class="error-404">
  <div class="content">
    <div class="bk_404"></div>
    <div class="desc">Oops~  您要找的页面已被雪藏<button @click="back">返回首页</button></div>
  </div>
  <div class="bk2"></div>
  </div>
</template>
<script type="text/babel">
export default {
  name: 'e404',
  methods: {
    back () {
      this.$router.push({name: 'login'})
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/error/e404/index.vue